<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeAccessoire.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a
              class="button is-addOrEdit"
              @click="checkPermissions(constantes.ACCESSOIRE.maj)
                ? showPopUpOpen(null, 'addOrEdit') : showPopUp()"
              :class="{
                'button-access-no-permission' : !checkPermissions(constantes.ACCESSOIRE.maj)
              }">
              {{ $t('listeAccessoire.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-12 pdr-0">
            <b-input
              :placeholder="$t('general.autocomplete.search')"
              type="search"
              icon="magnify"
              v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                  :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
    </div>
    <v-server-table
      @loaded="finLoading" @loading="debutLoading"
      :columns="columns" :options="options"
      class="tableWithPerPageSelection"
      ref="tableAccessoire">
      <div slot="fournisseur" slot-scope="props">
        <div v-if="props.row.fournisseurId">
          {{ props.row.fournisseur.nomCommercial }}</div>
      </div>
      <div slot="commentaire" slot-scope="props">
        <div>{{ props.row.commentaire }}</div>
      </div>
      <div slot="actif" slot-scope="props">
        <div>{{ getLibelleActif(props.row.actif) }}</div>
      </div>
      <div slot="edit" slot-scope="props">
        <div
          @click="checkPermissions(constantes.ACCESSOIRE.supprimer)
                 ? showPopUpOpen(props.row, 'addOrEdit') : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            icon="pencil-box-outline"
            type="is-success"
            :class="{ 'text-access-no-permission' : !checkPermissions(constantes.ACCESSOIRE.maj) }"
          />
        </div>
      </div>
      <div slot="archiver" slot-scope="props">
        <div
          @click="checkPermissions(constantes.ACCESSOIRE.supprimer)
            ? showPopUpOpen(props.row, 'archiver') : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            type="is-default"
            :icon="props.row.actif ? 'archive' : 'archive-arrow-up'"
            :class="{
              'text-access-no-permission' : !checkPermissions(constantes.ACCESSOIRE.supprimer),
            }"
          />
        </div>
      </div>
      <div slot="delete" slot-scope="props">
        <div
          @click="checkPermissions(constantes.ACCESSOIRE.supprimer)
           ? showPopUpOpen(props.row, 'delete') : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            type="is-danger"
            icon="delete-forever"
            :class="{
              'text-access-no-permission' : !checkPermissions(constantes.ACCESSOIRE.supprimer),
            }"
          />
        </div>
      </div>
    </v-server-table>
    <b-modal
      v-model="popUpAddEdit"
      has-modal-card
      class="modal">
      <pop-up-add-edit
        :item="item"
        @reload="recherche()"/>
    </b-modal>
    <b-modal v-model="popUpArchivage" has-modal-card
      class="modal" v-if="item">
      <pop-up-prevention :mess-header="item.actif
                          ? $t('listeAccessoire.popUpArchivage.titleArchiver')
                         : $t('listeAccessoire.popUpArchivage.titleDesarchiver')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         @yes="archiverDesarchiverAccessoire"
                         @no="popUpArchivage = false">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpDelete" has-modal-card
      class="modal" v-if="item">
      <pop-up-prevention :mess-header="$t('listeAccessoire.popUpDelete.title')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')"
                         :is-error-popup="errorPopUp"
                         :messages-popup="messagesPopup"
                         @yes="deleteAccessoire"
                         @no="popUpDelete = false">
      </pop-up-prevention>
    </b-modal>
    <div class="componentBrief" v-show="showFiltre">
      <filtre-accessoire  @toggleFiltre="setShowFiltre"
                          ref="filtreListeAccessoire"
                                 @recherche="makeRechercheFilter"/>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { ACCESSOIRE } from '@/configuration/gabed/permissionsGabedConf';
import genererAccessoire from '@/services/parametrage/generation/genererAccessoire';
import popUpAddEdit from '@/components/parametrage/accessoire/p_addEdit';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { archiver, deleteAccessoire } from '@/api/accessoire';
import popUpPrevention from '@/components/general/popUpPrevention';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageSuccess from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import filtreAccessoire from '@/components/parametrage/accessoire/filtreAccessoire';
import validationSuppression from '@/services/parametrage/validation/validationAccessoire';

const Permissions = createNamespacedHelpers('permissions');
const Accessoire = createNamespacedHelpers('accessoire');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      constantes: {
        ACCESSOIRE,
      },
      actions: [],
      item: null,
      popUpAddEdit: false,
      popUpArchivage: false,
      showFiltre: false,
      popUpDelete: false,
      errorPopUp: false,
      messagesPopup: [],
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    popUpAddEdit,
    popUpPrevention,
    filtreAccessoire,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Accessoire.mapGetters({
      accessoires: 'items',
      totalCount: 'totalCount',
      criteresRecherche: 'criteresRecherche',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('general.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeAccessoire.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeAccessoire.tab.libelle'),
          fournisseur: this.$t('listeAccessoire.tab.fournisseur'),
          commentaire: this.$t('listeAccessoire.tab.commentaire'),
          actif: this.$i18n.t('listeAccessoire.tab.actif'),
          edit: '',
          archiver: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          return this.actionsLoadLoadItems(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.accessoires,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          actif: 'colonneWidth130px',
        },
        sortable: ['libelle', 'actif'],
      };
    },
    columns() {
      return ['libelle', 'fournisseur', 'commentaire', 'actif', 'edit', 'archiver', 'delete'];
    },
    nombreCritere() {
      let nombreCritere = 0;
      nombreCritere += this.criteresRecherche.actif !== null ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Accessoire.mapActions({
      actionsLoadLoadItems: 'loadItems',
    }),
    ...Parametres.mapActions({
      loadParametreForce: 'loadParametreForce',
    }),
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs.tableAccessoire.refresh();
    },
    showPopUpOpen(item, type) {
      if (!item) this.item = genererAccessoire();
      else this.item = cloneDeep(item);
      switch (type) {
        case 'addOrEdit':
          this.popUpAddEdit = true;
          break;
        case 'archiver':
          this.popUpArchivage = true;
          break;
        case 'delete':
          this.popUpDelete = true;
          this.messagesPopup = [];
          this.errorPopUp = false;
          break;
        default:
          break;
      }
    },
    getLibelleActif(actif) {
      if (actif) return this.$t('general.non');
      return this.$t('general.oui');
    },
    async archiverDesarchiverAccessoire() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(this.item.id, this.item.actif);
        messageSuccess(this.item.actif
          ? this.$i18n.t('listeAccessoire.messages.success.archiver')
          : this.$i18n.t('listeAccessoire.messages.success.desarchiver'));
        await this.loadParametreForce(PARAMETRES_KEYS.accessoire);
        this.popUpArchivage = false;
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreListeAccessoire.initializeFiltre();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    async deleteAccessoire() {
      this.messagesPopup = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAccessoire(this.item.id);
        this.popUpDelete = false;
        messageSuccess(this.$i18n.t('listeAccessoire.messages.success.delete'));
        await this.loadParametreForce(PARAMETRES_KEYS.accessoire);
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationSuppression(e.response, this.messagesPopup);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    reinitialiser() {
      this.$refs.filtreListeAccessoire.initializeFiltre();
      this.$refs.filtreListeAccessoire.viderCritere();
      this.$refs.filtreListeAccessoire.appliquerCritere();
      this.showFiltre = false;
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageParametrage.accessoire.liste'));
  },
};
</script>
